import React from 'react';

import { TwoColorGraph } from '~/components/lawns/digital-soil-test/common/generic-graphs';
import Tooltip from '~/components/tooltip/tooltip';

import styles from '~/components/lawns/digital-soil-test/digital-soil-test.module.scss';

const OrganicMatterGraph = ({ organicMatter }) => (
  <div className={styles.graphContainer}>
    <h4 className={styles.graphTitle}>
      Organic matter{' '}
      <Tooltip content="Organic matter is the food source for soil life and plays a critical role in the soil's ecosystem. Organic matter develops from decaying plant roots, insects, and other organisms in the soil.  In turn, organic matter returns nutrients and resiliency to your lawn. Arid environments and new lawns tend to have relatively low organic matter." />{' '}
    </h4>
    {organicMatter < 5 && (
      <p className={styles.graphInfo}>
        Low organic matter isn't necessarily bad, but we can help raise it
      </p>
    )}
    <TwoColorGraph value={organicMatter < 5 ? 'low' : 'high'} />
  </div>
);

export default OrganicMatterGraph;
